import { Context } from '@nuxt/types/app'
import {
  getRouteGroup,
  setStoredEntryReferrer,
  clearStoredEntryReferrer
} from '~/utils/routeGroups'

export default function (context: Context) {
  if (!process.client) return

  const to = context.route
  const from = context.from

  if (!from?.name || !to?.name) return

  const toGroup = getRouteGroup(to.name)
  const fromGroup = getRouteGroup(from.name)

  // Entering a group from outside — snapshot the origin
  if (toGroup && fromGroup !== toGroup) {
    setStoredEntryReferrer(toGroup, {
      name: from.name,
      params: from.params,
      query: from.query
    })
  }

  // Leaving a group — clear the stored referrer
  if (fromGroup && toGroup !== fromGroup) {
    clearStoredEntryReferrer(fromGroup)
  }
}
